import React from 'react'
import { Select, IItemRendererProps, ItemListPredicate } from '@blueprintjs/select'
import { MenuItem } from '@blueprintjs/core'
import { Button, HighlightedText } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import fuzzy from 'fuzzaldrin-plus'
import { DateUtil, TIME } from '@utils/dateUtil'

export const createTimeOptions = (timezone: string, date?: string): DateUtil[] => {
  const moments = []

  // 24 hours @ 15 minute intervals, should start @ 12am and end with 11:45pm
  for (let i = 0; i < 24 * 4; i++) {
    // needs timezone and date applied
    const option = DateUtil.tz(date, timezone).set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    })
    option.add(15 * i, TIME.MINUTES)
    moments.push(option)
  }

  return moments
}

export default function TimeSelect({
  disabledOptionsIndexes,
  moments,
  onChange,
  value,
  disabled,
  buttonProps,
  timezone,
}: {
  disabledOptionsIndexes: number[]
  moments: DateUtil[]
  onChange: (value: string) => void
  value: string
  disabled: boolean
  buttonProps?: IUIButtonProps
  timezone: string
}) {
  if (!value) return null

  const formattedValue = DateUtil(value, timezone).format('h:mm a')
  const TimeSelect = Select.ofType<string>()

  return (
    <TimeSelect
      popoverProps={{ minimal: true, position: 'bottom' }}
      disabled={disabled}
      scrollToActiveItem
      activeItem={formattedValue}
      items={moments
        .map((m) => m.format('h:mm a'))
        .filter((_, i) => !disabledOptionsIndexes.includes(i))}
      onItemSelect={(string) => onChange(string)}
      itemListPredicate={filterTitles}
      itemRenderer={MomentRenderer}
    >
      <Button {...buttonProps} text={formattedValue}><span><i className="fa-light fa-angle-down" ></i></span></Button>
    </TimeSelect>
  )
}

function MomentRenderer(item: string, { handleClick, modifiers, query }: IItemRendererProps) {
  return (
    <MenuItem
      key={item}
      active={modifiers.active}
      disabled={modifiers.disabled}
      onClick={handleClick}
      text={
        <div className="flex items-center">
          <HighlightedText text={item} query={query} />
        </div>
      }
    />
  )
}

const filterTitles: ItemListPredicate<string> = (query, moments) => {
  return query ? fuzzy.filter(moments, query) : moments
}
